"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ConsoleIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ConsoleIcon, _React$PureComponent);

  function ConsoleIcon() {
    _classCallCheck(this, ConsoleIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConsoleIcon).apply(this, arguments));
  }

  _createClass(ConsoleIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'console-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M8.4961,6.0137 L5.5041,6.0047 C5.2251,6.0037 5.0011,5.7777 5.0021,5.4987 C5.0021,5.2207 5.2281,4.9957 5.5071,4.9967 L8.4991,5.0057 C8.7771,5.0067 9.0021,5.2327 9.0021,5.5117 C9.0011,5.7897 8.7741,6.0147 8.4961,6.0137 M3.8551,4.8537 L2.8691,5.8347 C2.6721,6.0307 2.3521,6.0297 2.1561,5.8317 C1.9601,5.6347 1.9611,5.3157 2.1581,5.1197 L2.7921,4.4897 L2.1621,3.8567 C1.9661,3.6587 1.9671,3.3397 2.1641,3.1437 C2.3621,2.9477 2.6811,2.9487 2.8771,3.1457 L3.8581,4.1327 C3.9571,4.2327 4.0061,4.3637 4.0041,4.4937 C4.0051,4.6237 3.9561,4.7547 3.8551,4.8537 M11.0001,0.9997 L1.0001,0.9997 C0.4471,0.9997 0.0001,1.4477 0.0001,1.9997 L0.0001,9.9997 C0.0001,10.5527 0.4471,10.9997 1.0001,10.9997 L11.0001,10.9997 C11.5531,10.9997 12.0001,10.5527 12.0001,9.9997 L12.0001,1.9997 C12.0001,1.4477 11.5531,0.9997 11.0001,0.9997"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ConsoleIcon;
}(_react.default.PureComponent);

exports.default = ConsoleIcon;
ConsoleIcon.defaultProps = {
  color: 'inherit'
};
ConsoleIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};